// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__30ekk","requiredAsterisk":"Info_requiredAsterisk__1Ph9q"};